import { useAPI } from '@providers/useAPI';
import { useQuery } from '@tanstack/react-query';
import { adminJobsKeys } from 'app/queries/adminJobs/adminJobsKeys';
import { useEffect } from 'react';
import { createFetchJobPipelineStatusQueryFn } from '../../../../../../api/fetchJobPipelineStatus';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { LiveIndicator, LiveStatusContainer, LiveText } from './styles/styles';

const POLLING_INTERVAL = 30000;

export const LiveStatusIndicator = () => {
  const { job, selectedAttemptId, loadAttemptDetails } = usePageContext();
  const { call } = useAPI();

  const isASOneJob = !!job?.meetingType;
  const jobId = job?.id ?? '';

  const statusQuery = useQuery({
    queryKey: adminJobsKeys.pipelineStatusByJob(jobId),
    queryFn: createFetchJobPipelineStatusQueryFn(call),
    enabled: isASOneJob && jobId !== '',
    refetchInterval: POLLING_INTERVAL,
  });
  const isLive = !statusQuery.isError && (statusQuery.data?.currentState?.toLowerCase().includes('running') ?? false);

  useEffect(() => {
    if (isLive && selectedAttemptId) {
      void loadAttemptDetails(selectedAttemptId);
    }
  }, [isLive, statusQuery.dataUpdatedAt]);

  if (!isASOneJob || !isLive) {
    return null;
  }

  return (
    <LiveStatusContainer>
      <LiveIndicator />
      <LiveText>Live</LiveText>
    </LiveStatusContainer>
  );
};
